import { useTranslation } from "react-i18next";
import classNames from "classnames";

import Button from "/components/Button";
import useScrolled from "/utils/use-scrolled";
import useFooterHeight from "/utils/use-footer-height";

// Sits at the bottom of the viewport alongside the left sidebar on the desktop
// layout; hidden on mobile by CSS, where the sidebar turns into a horizontal
// strip. Stays mounted so it can fade both in and out — the hidden state is
// `visibility: hidden`, which also keeps it out of the tab order.
export default function ScrollUpButton() {
  const { t } = useTranslation();
  const isScrolled = useScrolled();
  const footerHeight = useFooterHeight();

  const scrollUp = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div
      className={classNames("scroll-up-button-wrapper", { "scroll-up-button-wrapper--visible": isScrolled })}
      // Clears the footer, so the button never overlaps it at the end of the
      // scroll. Falls back to the stylesheet's offset until measured.
      style={footerHeight ? { bottom: `${footerHeight}px` } : undefined}
    >
      <Button onClick={scrollUp}>{t("common.scrollUp")}</Button>
    </div>
  );
}
